import { Country } from '../enums/locale-country.enum';

export class LocaleConstants {
	/**
	 * List of countries / locale which uses ',' as a decimal separator.
	 * This list can be further updated as we go on supporting more countries.
	 */
	public static readonly COMMA_DECIMAL_SEPARATOR_COUNTRIES = [
		Country.en_CH,
		Country.en_DE,
		Country.en_BE,
		Country.en_FR,
		Country.en_NL,
		Country.en_EE,
		Country.en_GR,
		Country.en_AT,
		Country.en_DK,
		Country.en_ES,
		Country.en_FI,
		Country.en_LT,
		Country.en_LU,
		Country.en_LV,
		Country.en_PL,
		Country.en_PT,
		Country.en_SE,
		Country.en_IT,
		Country.en_NO
	];
}
